import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getUserRecipes } from '../services/api';
import { useAuth } from '../context/authContext';
import RecipeCard from '../components/RecipeCard';
import RecipeBooks from '../components/RecipeBooks';
import TwoFolderFlaps from '../components/TwoFolderFlaps';
import '../styles/MyRecipes.css';

const MyRecipes = () => {
    const [activeTab, setActiveTab] = useState(0); // 0 for Recipes, 1 for Books, 2 for Nutrition
    const [recipes, setRecipes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { user } = useAuth();

    const tabs = ['Recipes', 'Books', 'Nutrition'];

    useEffect(() => {
        async function fetchUserRecipes() {
            if (!user?.uid) return;

            try {
                setLoading(true);
                const userRecipes = await getUserRecipes(user.uid);
                setRecipes(userRecipes);
            } catch (error) {
                console.error('Error fetching user recipes:', error);
                setError('Failed to load your recipes');
            } finally {
                setLoading(false);
            }
        }

        fetchUserRecipes();
    }, [user]);

    const handleTabChange = (tabIndex) => {
        setActiveTab(tabIndex);
    };

    if (loading) {
        return (
            <div className="myrecipes-container">
                <div className="loading">Loading your recipes...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="myrecipes-container">
                <div className="error">{error}</div>
            </div>
        );
    }

    return (
        <div className="myrecipes-container">
            <TwoFolderFlaps 
                tabs={tabs}
                activeTab={activeTab}
                onTabChange={handleTabChange}
            >
                {activeTab === 0 && (
                    <div className="recipes-section">
                        <div className="recipes-header">
                            <Link to="/create" className="btn btn-primary create-recipe-btn">
                                Create Recipe
                            </Link>
                        </div>
                        <div className="recipes-grid">
                            {recipes.length === 0 ? (
                                <div className="no-recipes">
                                    <p>You haven't created any recipes yet.</p>
                                    <Link to="/create" className="btn btn-primary">
                                        Create Your First Recipe
                                    </Link>
                                </div>
                            ) : (
                                recipes.map(recipe => (
                                    <RecipeCard key={recipe.id} recipe={recipe} />
                                ))
                            )}
                        </div>
                    </div>
                )}
                
                {activeTab === 1 && (
                    <RecipeBooks />
                )}

                {activeTab === 2 && (
                    <div className="nutrition-section">
                        <h2>Nutrition</h2>
                        <p>Nutrition information and tracking will appear here.</p>
                        {/* Add Nutrition component here when available */}
                    </div>
                )}
            </TwoFolderFlaps>
        </div>
    );
};

export default MyRecipes;